<script setup lang="ts">
import { computed } from 'vue'
import { InformationCircleIcon } from '@heroicons/vue/24/outline'
import { useHelpDrawerStore } from '@/stores/useHelpDrawerStore'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'

/**
 * Petit bouton d'ouverture de l'aide contextuelle, à placer à côté d'un titre
 * (page ou modale). La clé du contexte est déclarée via `useContextualHelp`.
 *
 * Visibilité :
 *  - utilisateur normal : visible si une doc *utilisateur* existe ;
 *  - USER_MASTER : visible si une doc (user *ou* dev) existe.
 */
const helpStore = useHelpDrawerStore()
const permissionStore = useBoostCorePermissionStore()

const visible = computed(() =>
  permissionStore.include('USER_MASTER') ? helpStore.available : helpStore.hasUser,
)
</script>

<template>
  <button
    v-if="visible"
    type="button"
    class="btn btn-ghost btn-sm btn-circle text-primary"
    aria-label="Afficher l'aide"
    title="Afficher l'aide"
    @click="helpStore.toggle()"
  >
    <InformationCircleIcon class="h-5 w-5" aria-hidden="true" />
  </button>
</template>
